import { render, staticRenderFns } from "./interactiveDetail.vue?vue&type=template&id=1c141e25&"
import script from "./interactiveDetail.vue?vue&type=script&lang=js&"
export * from "./interactiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./interactiveDetail.vue?vue&type=style&index=0&id=1c141e25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports